export const chartColors = [
  'var(--chakra-colors-blue)',
  'var(--chakra-colors-orange)',
  'var(--chakra-colors-sky-blue)',
  'var(--chakra-colors-purple)',
  'var(--chakra-colors-blue-600)',
  'var(--chakra-colors-yellow)',
  'var(--chakra-colors-blue-700)',
  'var(--chakra-colors-orange-600)',
  'var(--chakra-colors-green)',
  'var(--chakra-colors-purple-600)',
  'var(--chakra-colors-red-600)',
];
